import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getHolidayList = createAsyncThunk('holiday/getHolidayList',
  async () => {
    const url = `v1/holidays`
    const response: AxiosResponse<Holiday[]> = await instance.get(url)
    return response.data
  })

export const createHoliday = createAsyncThunk('coupon/createHoliday',
  async (data: HolidayPayload) => {
    const response: AxiosResponse<CouponState> = await instance.post('v1/holidays', data)
    return response.data
  })

export const deleteHoliday = createAsyncThunk('coupon/deleteHoliday',
  async (id: string) => {
    const response: AxiosResponse<CouponState> = await instance.delete(`v1/holidays/${id}`)
    return response.data
  })

export const checkHoliday = createAsyncThunk('coupon/checkHoliday',
  async ({ date, venueId }: CheckHolidayQuery) => {
    const response: AxiosResponse = await instance.get(`v1/holidays/check${serializeQueryParam({ date, venueId })}`)
    return response.data
  })
